import View from '../core/view/View';
import Lang from '../core/lang/Lang';
import Model from '../core/model/Model';

/**
 * A helper view that simple renders html
 */
export default class Trans extends View<TransModel> {


	private _condition:number;
	private transTemplate:string;

	constructor() {
		super( { template:'', data:new TransModel( { condition:null, params:null } ) } );
	}

	render( target?:Element ) {

		// before render get inner html for item template.
		this.transTemplate = target.innerHTML;

		super.render( target );
	}

	init() {
		this.data.change.subscribe( this.onModelChange.bind( this ) );

		this.renderTranslation();
	}

	onModelChange() {
		this.renderTranslation();
	}

	renderTranslation() {
		var opt:any = {};
		if( this.data.condition != null ) opt.condition = this.data.condition;
		opt.data = ( this.data.params ) ? this.data.params : this.parent.template.dataFactory();

		this.node.innerHTML = Lang.translate( this.transTemplate, opt );
	}

}

class TransModel extends Model {
	condition:number;
	params:any;
}
